import Component from "../core/Component"
import Scroll, { scrollToElement } from "../services/Scroll"
import throttle from "lodash/throttle"
import enquire from "enquire.js"
import { queries } from "../core/config"

export const STATES = {}

export const EMITS = {
    SCROLL_CATEGORY_CHANGE: "scroll-category-change"
}

export default class GalleryGrid extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            categorys: [],
            placeholder: null
        }

        this.index = null
        this.isMobile = false
        this.handleScroll = throttle(this.handleScroll, 300)
        this.enquireHandler = {
            match: () => this.isMobile = true,
            unmatch: () => this.isMobile = false
        }
    }

    prepare() {
        this.ref.categorys.forEach(category => category.id = `gallerygrid-${category.id}`) //fake id aby neskakalo

        Scroll.on("scroll", this.handleScroll)
        enquire.register(queries.smallWideMax, this.enquireHandler)
        window.addEventListener("resize", this.handleResize)
    }

    destroy() {
        Scroll.off("scroll", this.handleScroll)
        enquire.unregister(queries.smallWideMax, this.enquireHandler)
        window.removeEventListener("resize", this.handleResize)
    }

    handleResize = () => {
        this.resize()
    }

    handleScroll = () => {
        if (this.isMobile) {
            return
        }

        const index = this.ref.categorys.findIndex(category => category === this.getCategoryInView())

        if (!~index || this.index === index) {
            return
        }

        this.index = index
        this.updateGrid()

        this.emit(EMITS.SCROLL_CATEGORY_CHANGE, { index })
    }

    select(index, useScrolling = true) {
        this.index = index
        this.updateGrid()

        if (!this.isMobile && useScrolling) {
            scrollToElement(this.ref.categorys[this.index])
        }

        this.resize()
    }

    updateGrid() {
        this.ref.categorys.forEach(category => category.classList.remove("is-active"))
        this.ref.categorys[this.index].classList.add("is-active")
    }

    resize() {
        const category = this.ref.categorys[this.index]
        if (!category) {
            return
        }
        this.ref.placeholder.style.height = `${category.getBoundingClientRect().height}px`
    }

    getCategoryInView() {
        let smallestNegativeNumberFound = Number.NEGATIVE_INFINITY
        let categoryInView = null
        const offset = -200

        this.ref.categorys.forEach(category => {
            const top = category.getBoundingClientRect().top + offset

            if (top < 0 && top > smallestNegativeNumberFound) {
                smallestNegativeNumberFound = top
                categoryInView = category
            }
        })

        return categoryInView
    }
}
